'use strict';

var ReactNativeFile = require('./ReactNativeFile.js');

module.exports = function isExtractableFile(value) {
  return typeof File !== 'undefined' && value instanceof File || typeof Blob !== 'undefined' && value instanceof Blob || value instanceof ReactNativeFile;
};